import { usePrevious } from '@mnd-frontend/hooks';
import { forceCollide, forceManyBody, forceSimulation, forceX, forceY } from 'd3-force';
import { useMemo } from 'react';

function forceBoundary(width: any, height: any, padding: any) {
  let nodes: any;

  function force() {
    for (let r, i = 0; i < nodes.length; i += 1) {
      r = nodes[i].r + padding;
      nodes[i].x = Math.max(r, Math.min(width - r, nodes[i].x));
      nodes[i].y = Math.max(r, Math.min(height - r, nodes[i].y));
    }
  }

  force.initialize = (_: any) => {
    nodes = _;
  };

  return force;
}

export default function useForce(nodes: any, width: any, height: any, padding: any) {
  // prettier-ignore
  const simulation = useMemo(
    () =>
      nodes.length
        ? forceSimulation(nodes)
            .alphaMin(0.01) // default 0.001 -> the smaller, the longer is the simulation running
            .velocityDecay(0.5) // default 0.4 -> the higher, the faster the simulation cools down
            .force(
              'gravity',
              (forceManyBody().strength((d: any) => d.r * d.r * 0.005) as any).distanceMin(
                (d: any) => d.r + padding,
              ),
            )
            .force('centerX', forceX(0.5 * width).strength(0.25 * (height / width ** 2)))
            .force(
              'centerY',
              forceY(0.5 * height).strength(
                (d: any) => Math.sqrt(d.r) * 0.04 * (width / height ** 2),
              ),
            )
            .force(
              'collision',
              forceCollide().radius((d: any) => d.r + 1 + padding / 2),
            )
            .force('boundary', forceBoundary(width, height, padding))
        : null,
    [nodes, width, height, padding],
  );
  const prev = usePrevious(simulation);
  if (prev && prev !== simulation) prev.stop();
  return simulation;
}
